<button type="submit" [class]="type=='block'?'btn btn-primary btn-block mt-2':'btn btn-primary'"
    (click)="solicitarInformacion(solicitarModal)">Solicitar
    Información</button>{{getSeparation()}}
<ng-template #solicitarModal let-modal>
    <form name="form" (ngSubmit)="f.form.valid && enviarSolicitud()" #f="ngForm">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Solicitar información</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <label for="dateOfBirth">Ingrese la información que requiere</label>
                <textarea class="form-control" name="mensajeSolicitud" #mensajeSolicitud="ngModel"
                    [ngClass]="{'is-invalid':  f.submitted && mensajeSolicitud.invalid}" required
                    [(ngModel)]="solicitud.texto_solicitud"></textarea>
                <div *ngIf="f.submitted && mensajeSolicitud.invalid" class="invalid-feedback">
                    <div *ngIf="mensajeSolicitud.errors.required">El mensaje es requerido</div>
                </div>
            </div>
            <div class="form-group">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" name="archivos" id="archivos"
                        [(ngModel)]="solicitud.incluye_archivos" />
                    <label class="form-check-label" for="archivos">¿Requiere archivos?</label>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-outline-dark">Enviar solicitud</button>
        </div>
    </form>
</ng-template>